import * as types from './types'

const intitialState = {
    list: [],
}

const compareUserReducer = (state = intitialState, action) => {
    switch (action.type) {
        case types.COMPARE_USER: {
            return {
                ...state,
                ...action.payload
              }
        }             
        case types.COMPARE_USER_ERR: {
            return intitialState
        }
        case types.RESET_COMPARE_USER: {
            return intitialState
        }    
        default:
            return state;
    }

}

export default compareUserReducer